<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right" v-if="this.project_id">
    <OrderListHeader />
    <v-divider style="margin-bottom: 5px;margin-top: 5px;"></v-divider>
    <div style="margin-bottom: 3px;">当前项目：{{project_name1}}</div>
    <div style="margin-bottom:1px">
      <el-button size="mini" type="primary text2" @click="xiugai" >费用收付</el-button>
      <!-- <el-input size="mini" class="search" placeholder="请输入搜索内容" v-model="search" clearable></el-input> -->
      <el-select
          v-model="search"
          class="search"
          size="mini"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="可搜索房产/客户姓名"
          :remote-method="remoteMethod"
          @change="changes"
          :loading="loading">
          <el-option
            v-for="item in selectList"
            :key="item.id"
            :label="item.house"
            :value="item.house">
          </el-option>
        </el-select>

      <el-select size="mini" v-model="chargeitemID" filterable placeholder="费用类型" class="kuan">
        <el-option
          key=""
          label="全部费用"
          value="">
        </el-option>
        <el-option
          v-for="item in chargeitem"
          :key="item.id"
          :label="item.chargeItem_name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-date-picker size="mini"
        v-model="datevalue"
        type="daterange"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>

      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
      <!-- <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出</el-button> -->
    </div>

    <div style="width: 80%;display: flex;flex-wrap: wrap;margin-bottom: 10px;">
        <div>收款方式：</div>
        <div v-for="it in dataPay">
            <div style="margin-left: 10px;">
              <el-radio v-model="radio" :label="it.number">{{it.name}}</el-radio>
            </div>
        </div>
    </div>

    <div style="display: flex;color: red;margin-top: -5px;">
      <div style="width: 60%;margin-top: 10px;">
        <div v-if="sumMoney>0">总金额：￥{{sumMoney}}元  当前客户：{{customerName}}</div>
        <div v-else>总金额：￥{{money}}元 &nbsp&nbsp&nbsp 当前客户：{{customerName}}</div>
      </div>
      <!-- <div style="position: absolute;right: 30px;margin-top: -13px;"> -->
      <div style="width: 40%;text-align: right;margin-right: 10px;margin-bottom: 5px;">
        <el-button size="mini" type="primary text2" @click="bindGroupBy(1)">明细</el-button>
        <el-button size="mini" type="primary text2" @click="bindGroupBy(2)">收费周期</el-button>
      </div>
    </div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                选择
                <el-checkbox v-if="ERP.isPermission(4003007006)" v-model="checkbox_all" true-label='all'></el-checkbox>
              </th>
              <th class="text-left" v-if="group_by===1">房产</th>
              <th class="text-left">收费项</th>
              <th class="text-left">单价</th>
              <th class="text-left">用量面积</th>
              <th class="text-left">计费周期</th>
              <th class="text-left">应收日期</th>
              <th class="text-left">本期应收</th>
              <th class="text-left">本期欠费</th>
              <th class="text-left">减免金额</th>
              <th class="text-left">违约金</th>
              <th class="text-left">减免违约金</th>
              <th class="text-left">操作</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
            <tr class="text1" v-for="(item,index) in desserts" :key="index">
              <td>
                <div style="display: flex;">
                  <div v-if="item.state==1 && ERP.isPermission(4003007006)">
                    <el-checkbox v-model="checked['checked'+index]" @change="checkeds(item.default_in_this_period,checked.checked0)" :true-label='item.ids'></el-checkbox>
                  </div>
                  <div v-else>
                    <el-checkbox disabled></el-checkbox>
                  </div>
                  <!--            <div style="margin-left: 5px;">{{item.id}}</div>-->
                </div>
              </td>
              <td v-if="group_by===1">{{item.h_name_date}}</td>
              <td style="text-align: left;">{{item.charge_name}}</td>
              <td>{{item.xsc_Price}}</td>
              <td >{{item.xsc_Amount}}</td>
              <td >
                  {{item.min_date}} 至 {{item.max_date}}
              </td>
              <td>{{item.max_ymt}}</td>
              <td>{{item.receivable_in_the_current_period}}</td>
              <td>{{item.default_in_this_period}}</td>
              <td>
                <template v-if="group_by===1 && ERP.isPermission(4003007005)">
                  <input style="width: 60px;border: 1px solid #eeeeee;background-color: #ffffff; text-align: center;" size="small" v-model="item.charge_1" :title="item.discount" @change="setTableMoney(index)" />
                </template>
                <template v-else>
                  {{item.discount}}
                </template>
              </td>
              <td>{{item.delaySum}}</td>
              <td>
                <template v-if="group_by===1 && ERP.isPermission(4003007005)">
                  <input style="width: 60px;border: 1px solid #eeeeee;background-color: #ffffff; text-align: center;" size="small" v-model="item.charges_1" :title="item.delayDiscount" @change="setTableMoney(index)" />
                </template>
                <template v-else>
                  {{item.delayDiscount}}
                </template>
              </td>
              <td class="cdj_td">
                <div style="cursor:pointer;" v-if="ERP.isPermission(4003001004)&& group_by===2">
                  <div @click="chakan(item)">详情</div>
                </div>
                <div style="cursor:pointer;" v-if="ERP.isPermission(4003001004)&& group_by===1">
                  <div @click="chakan2(item)">详情</div>
                </div>

                <div style="cursor:pointer;" v-if="item.state==1 && ERP.isPermission(4003007005)&& group_by===1">
                  <div style="color: #1867c0;margin-left: 5px;" @click="reduction(item)">减免</div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>

     <Modal
       v-model="modal12"
        ok-text="确定"
        width="500"
        title="查看详情">
        <div v-if="chakana['id']">
           <p>ID：{{chakana['id']}}</p>
           <p>房产ID：{{chakana['house_id']}}</p>
           <p>生成组ID：{{chakana['weiyi']}}</p>
           <p>编号：{{chakana['number']}}</p>
           <p>姓名：{{chakana['h_name']}}</p>
           <p>组织id：{{chakana['company_id']}}</p>
           <p>项目：{{chakana.h_name_date}}</p>
           <p>收费项：<span v-if="chakana.charge_name">{{chakana.charge_name}}</span><span v-else>{{chakana.xsc_ChargeName}}</span></p>
           <p>实收金额：{{chakana['charge']}}</p>
           <p>应收金额：{{chakana['chargePay']}}</p>
           <p>减免金额：{{chakana['discount']}}</p>
           <p>违约金额：{{chakana['delaySum']}}</p>
           <p>违约天数：{{chakana['delayDays']}}</p>
           <p>减免违约金额：{{chakana['delayDiscount']}}</p>
           <p>已缴金额：{{chakana['PaidChargeSum']}}</p>
           <p>状态：<span v-if="chakana.state==1">待支付</span><span v-if="chakana.state==2">已完成</span></p>
           <p v-if="chakana.remark != ''">备注：{{chakana['remark']}}</p>
           <p>生成时间：{{chakana['generate_date']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">仪表编号：{{chakana['ybiao']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">抄表读数：{{chakana['chaobiaodushu']}}</p>
           <p v-if="chakana.ymt1==''">抄表人或负责人：{{chakana['chaobiaoname']}}</p>
           <p v-if="chakana.explain != ''">收费说明：{{chakana['explain']}}</p>
           <p>计费开始：{{chakana.startDate}}</p>
           <p><span >计费结束：{{chakana.endDate}}</span></p>
           <p v-if="chakana['log_name']!=null">后台付款操作人：{{chakana['log_name']}}</p>
        </div>
     </Modal>
     <!-- 减免 -->
     <Modal
        v-model="reductions"
        ok-text="确定"
        width="500"
        @on-ok="cdj_reduction"
        title="减免(折扣)">
        <div>
          <div>收费金额：{{order.charge}}</div>
          <div>应收金额：{{order.chargePay}}</div>
          <div>已缴金额：{{order.PaidChargeSum}}</div>
          <div>违约天数：{{order.delayDays}}</div>
          <div>违约金额：{{order.delaySum}}</div>
          <div>减免金额：{{order.discount}}</div>
          <div>减免违约金额：{{order.delayDiscount}}</div>
          <RadioGroup v-model="buttonSize" type="button" style="margin-top:10px">
              <Radio label="1">按金额减免</Radio>
              <Radio label="2">按百分比减免</Radio>
          </RadioGroup>
          <div style="margin-top: 10px;">减免金额公式：原总金额 - 减免金额 = 需支付金额</div>
          <div>减免违约金公式：原违约金总金额 - 减免金额 = 需支付金额</div>
          <div style="color: red;">注意：当前欠费金额 {{order.charge}} - {{order.PaidChargeSum}} = {{money_charge}}</div>
          <br>
          <div>
            减 免 金 额：{{priceCharge}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charge">
            = {{price}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage">%</span>
          </div>
          <div style="margin-top: 3px;">
            减免违约金：{{Number(order.delaySum)}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charges">
            = {{prices}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage1">%</span>
          </div>
        </div>
     </Modal>

    <Modal
      v-model="modal13"
      :footer-hide="true"
      width="90%"
      :mask="true"
      title="查看详情">
      <OrderList3 ref="OrderList3" v-if="modal13"></OrderList3>
    </Modal>
    </div>

    <!-- 打印display: none; -->
    <div style="position: absolute;bottom: 100px;left: 500px;width: 700px;display: none;">
      <div id='printBill'>
        <div style="font-size: 8px;color: #141414;font-family: 楷体;">
          <div style="width: 100%;text-align: center;margin-top: 30px;font-size: 20px;">中奥物业 收款收据</div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 70%;">房号：{{goods.h_name_date}}</div>
            <div style="width: 30%;margin-left: 220px;">付款方式：{{goods.pays}}</div>
          </div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;">业主：{{goods.h_name}}</div>
            <div style="width: 33%;">收据单号：{{goods.bill_number}}</div>
            <div style="width: 34%;text-align: right;margin-right: 25px;">开票日期：{{goods.date1}}</div>
          </div>
          <div style="margin-top:1px;line-height: 17px;">
            <table align="center" style="width: 100%;border-collapse: collapse;">
                <tr>
                    <th style="border:1px solid #000000;width: 150px;" align="center" valign="middle">收费项目</th>
                    <th style="border:1px solid #000000;width: 200px;" align="center" valign="middle">计费周期</th>
                    <th style="border:1px solid #000000;width: 90px;" class="ddd" align="center" valign="middle">面积</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">数量</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">单价</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">违约金</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">金额</th>
                </tr>
                <tr v-for="it in orders">
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.chargeitem_name}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.startDate}}-{{it.endDate}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charging}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.xsc_Amount}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charges}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.delaySum}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charge}}</td>
                </tr>
                <tr>
                    <td style="border:1px solid #000000;" align="center" valign="middle">合计（大写）：</td>
                    <td style="border:1px solid #000000;text-align: left;" colspan="4" align="center" valign="middle">
                      <span style="margin-left: 5px;">{{capitalize}}</span>
                    </td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">（小写）：</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{goods.charge}}</td>
                </tr>
                <tr>
                    <td style="border:1px solid #000000;" align="center" valign="middle">备注：</td>
                    <td style="border:1px solid #000000;text-align: left;" colspan="6" align="center" valign="middle">
                      <span style="margin-left: 5px;">{{goods.beizhus}}</span>
                    </td>
                </tr>
            </table>
          </div>
          <div style="width: 70%;margin-top: 20px;">说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）</div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;">开票人：{{login}}</div>
            <div style="width: 33%;">收款人：{{login}}</div>
            <div style="width: 34%;text-align: right;margin-right: 150px;">收款单位（盖章）</div>
          </div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;"></div>
            <div style="width: 33%;"></div>
            <div style="width: 34%;text-align: right;margin-right: 70px;">
              打印时间：{{goods.date2}}
            </div>
          </div>
          <div style="text-align: center;margin-top: 7px;">打印次数<span style="margin-left: 30px;">{{goods.frequency}}</span></div>
        </div>
      </div>
    </div>
</div>

</template>

<script>
import OrderList3 from "./List3";
import OrderListHeader from "../Common/OrderListHeader";
import print from 'print-js';
export default {
  name: 'OrderList2',
  data () {
    return {
      project_name1:'',
      goods:[],
      login:'',
      capitalize:'',
      orders:[],
      selectList:[],
      project_name:'',
      project_id:'',
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      money:'--',
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
       options: [
        {
          value: '',
          label: ''
        },],
       options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
        ],
      value: '',
      value1:'',
      value2:1,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:1,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      modal13:false,
      group_by:2,
      checkbox_all:'',
      dataPay:[],
      radio:'',
      sumMoney:0,
      money_charge:0,
      customerName: ''
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.login = window.localStorage.getItem('login');
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
      this.value = backdata.data;
      this.$Loading.finish();
      ERP.hideLoading()
      this.moneys();
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          let dataPay = backdata.data.data;
          this.dataPay = dataPay;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //搜索框选中房产
    changes(e){
      this.change(1);
    },
    //核销金额合计
    checkeds(money,checked){
      this.$myhttp.post('admin/Order/money',{checked:this.checked,'radio':this.radio},{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.sumMoney = backdata.data.money;
      });
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      let searchs = '';
      if(this.project_name != '' && this.project_name != null){
        searchs=this.project_name;
      }
      if(this.search != '' && this.search != null){
        searchs = this.search;
        this.project_name = searchs;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ searchs +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          console.log(333);
          this.$Loading.finish();
      });
    },
    //查询总欠费
    moneys(){
      let searchs = '';
      if(this.project_name != '' && this.project_name != null){
        searchs=this.project_name;
      }
      if(this.search != '' && this.search != null){
        searchs = this.search;
        this.project_name = searchs;
      }
      this.$myhttp.get('admin/getMoney2?search='+ searchs + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+'&tm_limit='+this.datevalue,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data['money'];
      });
    },
    setTableMoney(index){
      var that=this;
      that.order=this.desserts[index];
      that.charge=that.order.charge_1;
      that.charges=that.order.charges_1;
      setTimeout(function () {
        that.cdj_reduction()
      },200);
    },
    //减免（折扣）
    cdj_reduction(){
      var order = this.order;
      //收费金额
      var charge = this.price;
      //减免收费金额
      var discount = this.charge;
      //违约金额
      var delaySum = this.prices;
      //减免违约金额
      var delayDiscount = this.charges;
      var data = {
        id:order.id,
        charge:charge,
        discount:discount,
        delaySum:delaySum,
        delayDiscount:delayDiscount
      };
      var delaySum1 = Number(delaySum)+Number(delayDiscount);
      var charge1 = Number(charge)+Number(discount);
      if(delaySum1.toFixed(2) < Number(delayDiscount) || charge1.toFixed(2) < Number(discount)){
        // this.$Message.error('金额不合法');
        this.$alert('金额不合法', '提示')
        return false;
      }

      // console.log(data)
      this.$myhttp.post('admin/orderDiscount',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.searchs();
          // this.$Message.success('操作成功!');
        this.$alert('操作成功!', '提示')
      });
    },
    //弹窗查看
    chakan(item){
      console.log(item);
      // this.chakana = e;
      // this.modal12 = true;
      var that=this;
      that.modal13=true;
      setTimeout(function (){
        that.$refs.OrderList3.setOptData({
          roomName:item.h_name_date,
          year:item.Y,
          yearMoney:item.year_money,
          chargeId:item.charge_item_id,
          state:that.state
        })
      },200);

    },
    chakan2(e){
      console.log(e);
      this.chakana = e;
      this.modal12 = true;
    },
    //减免
    reduction(item){
      this.itemOrder = item;
      if(this.reductions == false){
        this.buttonSize = "1";
        this.reductions = true;
      }
      this.order = item;
      //当前欠费
      this.money_charge = Number(this.order.charge) - Number(this.order.PaidChargeSum);
      this.money_charge = this.money_charge.toFixed(2);

      var delaySum = Number(this.order.delaySum)-Number(this.order.delayDiscount);
      var priceCharge = Number(this.order.charge) + Number(this.order.discount) - delaySum;
      this.priceCharge = priceCharge.toFixed(2);//原总金额
      this.charge = Number(item.discount);
      var priceCharges = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.order.discount) + Number(this.order.delayDiscount);
      this.price = priceCharges.toFixed(2);//收费金额
      this.charges = Number(item.delayDiscount);
      var prices = Number(item.delaySum) - Number(item.delayDiscount);
      this.prices = prices.toFixed(2);
    },
    //确定付款(核销)
    xiugai(){
      if(this.radio == ""){
        this.$Message.error('请选择收款方式!');
        return false;
      }
      this.$confirm('确定核销吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listXiuGai',{checked:this.checked,'radio':this.radio},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading=false;
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }
              if(backdata.data.code == 200){
                this.checked={
                  checked0:'',
                  checked1:'',
                  checked2:'',
                  checked3:'',
                  checked4:'',
                  checked5:'',
                  checked6:'',
                  checked7:'',
                  checked8:'',
                  checked9:'',
                  checked10:'',
                  checked11:'',
                };
                //console.log(backdata.data);
                this.prints(backdata.data.data.id)
                this.change(1)
                this.loading=false;
                this.$Message.success('操作成功!');
              }
          });
        }).catch(() => {

        });
    },

    //是否打印
    prints(id){
      this.$confirm('是否打印票据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.billPrintClick(id)
        }).catch(() => {

        });
    },
    //打印
     billPrintClick(ids){
      let item = {id:ids}
      this.login = window.localStorage.getItem('login');
      this.$myhttp.post('admin/getPrint',item,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.goods = backdata.data.goods;
            this.orders = backdata.data.order;
            this.capitalize = this.transCnMoney(this.goods.charge);
            this.day();
      });
    },
    //数字转大写
    transCnMoney(number){
       var CN_MONEY = "";
       var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
          number =  parseFloat(number).toFixed(2).toString();//浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
       var dot = number.indexOf('.');//将从小数点开始分开
       if(dot >=0){
          number = number.substring(0,dot)+number.substr(dot+1,2);
          CN_UNIT=CN_UNIT.substr(CN_UNIT.length-number.length);
          for (var i = 0; i < number.length; i++){
           CN_MONEY += '零壹贰叁肆伍陆柒捌玖'.substr(number.substr(i, 1), 1) + CN_UNIT.substr(i, 1);
          }
          return CN_MONEY.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
        }else{

        }
    },
    //打印
    day(){
      let _this = this;
      setTimeout(function(){
        const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
        printJS({
          printable: 'printBill',// 标签元素id
          type: 'html',
          header: '',
          targetStyles: ['*'],
          scanStyles:false,//打印必须加上，不然页面上的css样式无效
          style,
          //打开打印界面
          onLoadingStart: () => {
            console.log('loading-start')
          },
          //界面打开成功结束
          onLoadingEnd: () => {
            console.log('loading-end')
          },
          //关闭回调
          onPrintDialogClose: () => {
            console.log("关闭回调")
          },
          onError: e => {
            console.log('打印失败')
          },
        });
      },100)
    },


    modals(e){
      if(this.state != e){
        this.state = e;
        this.money = "--";
        this.change(1);
        this.moneys();
      }
    },
    //获得当前多少页,分页
    change(e){
      var that=this;
      if(!this.search){
        this.$alert("请选择房产!");
        return false;
      }
      let searchs = '';
      if(this.project_name != '' && this.project_name != null){
        searchs=this.project_name;
      }
      if(this.search != '' && this.search != null){
        searchs = this.search;
        this.project_name = searchs;
      }

      ERP.showLoading()
      that.$Loading.start();
      that.$myhttp.getRequest({
        url:"admin/orderList4",
        data:{
          id:e,
          search:searchs,
          company:that.value,
          company1:that.value2,
          state:that.state,
          chargeitemID:that.chargeitemID,
          homeName:that.homeName,
          tm_limit:that.datevalue,
          group_by:that.group_by
        }
      },data=>{ // 异步执行成功后
        that.desserts = (data[0]||[]).map(ret=>{
          ret.charge_1=ret.discount;
          ret.charges_1=ret.delayDiscount;
          return ret;
        });

        // 动态勾选
        var checked = {};
        that.desserts.map((req,index)=>{
          checked['checked'+index] = ""
        })
        this.checked = checked;
        that.customerName = data[3];
        that.total = data[1];
        that.page = data[2];
        that.$Loading.finish();
        ERP.hideLoading()
      },err=>{
        this.$Loading.finish();
        ERP.hideLoading()
        that.$alert("请求异常！")
      })
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.money = "--";
                this.change(1);
                this.$Message.success('删除成功!');
                this.moneys();
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 树组件点击触发
    nodeClick(data) {
      this.sumMoney = 0;
      // console.log(data);
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      this.project_name1 = project.name;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.project_name = tree_str;
      //console.log(data.tree)
      // this.homeName=tree_str;
      // this.change(1);
      this.value2=4;
      if(data.tree[data.tree.length-1].type==='room'){
        this.search=tree_str;
        // this.remoteMethod(tree_str);
        this.change(1);
        this.moneys();
      }
    },
    bindGroupBy(group_by){
      this.group_by=group_by;
      this.change(1)
    }
  },
  watch:{
      charge(){
        var price = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.charge) + Number(this.order.delayDiscount);
        this.price = price.toFixed(2);
        if(this.price < 0){
          this.$Message.error('减免金额不合法');
          return false;
        }
      },
      charges(){
        var prices = Number(this.order.delaySum) - Number(this.charges);
        this.prices = prices.toFixed(2);
        if(this.prices < 0){
          this.$Message.error('减免违约金额不合法');
          return false;
        }
      },
      //减免是按金额减免还是按百分比减免切换
      buttonSize(){
        this.chargePercentage = '';
        this.chargePercentage1 = '';
        this.reduction(this.itemOrder);
      },
      //减免金额百分比
      chargePercentage(){
        this.charge = Number(this.priceCharge)*(Number(this.chargePercentage)/100);
        this.charge = this.charge.toFixed(2);
      },
      //减免违约金百分比
      chargePercentage1(){
        this.charges = Number(this.order.delaySum)*(Number(this.chargePercentage1)/100);
        this.charges = this.charges.toFixed(2);
      },
    checkbox_all:function (n) {
      let _this = this;
      let che = Object.keys(_this.checked);
      if(!n){
        che.map((req,index)=>{
          _this.checked['checked'+index] = '';
        })
      }else {
        che.map((req,index)=>{
          _this.checked['checked'+index] = (_this.desserts[index]||{}).ids||'';
        })
      }
      this.checkeds(1,1);
      //console.log(n,this.checked)
    }
  },

  components: {
    OrderListHeader,
    OrderList3,
    "erp-tree": () => import('../Common/erp-tree.vue')
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 300px;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/List2.vue